// extracted by mini-css-extract-plugin
module.exports = {"HeaderHomer":"header_HeaderHomer__YwTwJ","loginHome":"header_loginHome__2ELC1","logo":"header_logo__3jaeZ"};